export default __webpack_public_path__ + "static/media/iqooLogo.10af47b2.svg";